'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$getPrototypeOf = _interopDefault(require('babel-runtime/core-js/object/get-prototype-of'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));
var _possibleConstructorReturn = _interopDefault(require('babel-runtime/helpers/possibleConstructorReturn'));
var _get = _interopDefault(require('babel-runtime/helpers/get'));
var _inherits = _interopDefault(require('babel-runtime/helpers/inherits'));
var $ = _interopDefault(require('jquery'));
var enquire = _interopDefault(require('enquire.js'));
var Breakpoints = _interopDefault(require('../global/breakpoints.js'));
var utils_js = require('../helpers/utils.js');
var Accordion = _interopDefault(require('./accordion.js'));
var Tabs = _interopDefault(require('./tabs.js'));

var breakpoints = new Breakpoints();

var TabbedCarousel = function (_Tabs) {
  _inherits(TabbedCarousel, _Tabs);

  function TabbedCarousel(el) {
    _classCallCheck(this, TabbedCarousel);

    var _this = _possibleConstructorReturn(this, (TabbedCarousel.__proto__ || _Object$getPrototypeOf(TabbedCarousel)).call(this, el, {
      tabNav: '.tabbed-carousel__nav',
      tabNavItems: '.tabbed-carousel__nav-item',
      tabItems: '.tabbed-carousel__item',
      setInitialState: false
    }));

    var $el = utils_js.isJquery(el) ? el : $(el);
    if (!$el.length) {
      return _possibleConstructorReturn(_this);
    }

    _this.$tabNav = _this.$el.find(_this.config.tabNav);
    _this.$tabNavItems = _this.$el.find(_this.config.tabNavItems);
    _this.$tabItems = _this.$el.find(_this.config.tabItems);

    _this.enable = _this.enable.bind(_this);

    _this.enable();
    return _this;
  }

  _createClass(TabbedCarousel, [{
    key: 'enable',
    value: function enable() {
      // Accordion contains its own logic for enable/disable on breakpoints
      this.accordion = new Accordion(this.$el);

      // TabbedCarousel only adds Carousel at >= breakpoints.tablet
      enquire.register([breakpoints.tablet, breakpoints.desktop].join(','), this.setInitialState);
      enquire.register(breakpoints.phone, this.removeState);
    }
  }, {
    key: 'updateState',
    value: function updateState() {
      _get(TabbedCarousel.prototype.__proto__ || _Object$getPrototypeOf(TabbedCarousel.prototype), 'updateState', this).call(this);

      this.$nextLabel = this.$el.find('.carousel-arrow-right .tab-label');
      this.$prevLabel = this.$el.find('.carousel-arrow-left .tab-label');

      // Update arrow text
      this.$nextLabel.text(this.carousel.$navItems.eq(this.carousel.nextIndex).text().trim());
      this.$prevLabel.text(this.carousel.$navItems.eq(this.carousel.prevIndex).text().trim());
    }
  }]);

  return TabbedCarousel;
}(Tabs);

module.exports = TabbedCarousel;
